/**
 * JKL Newsletter (snippet jkl-newsletter, used by jkl-newsletter and jkl-newsletter-image sections)
 *
 * - Marks the newsletter page as the source when its form is submitted, so the footer
 *   newsletter doesn't show its own success state (see jkl-footer.js)
 * - Scrolls to the newsletter after a successful submission
 * - Consent validation lives in jkl-newsletter-consent.js (shared with the footer)
 */

(function () {
  function initNewsletter(newsletter) {
    // Avoid binding listeners twice on the same newsletter element
    if (newsletter.dataset.newsletterInitialized) return;
    newsletter.dataset.newsletterInitialized = "true";

    const form = newsletter.querySelector("form");
    if (form) {
      form.addEventListener("submit", function () {
        sessionStorage.setItem("newsletter_submitted_from", "page");
      });
    }

    if (newsletter.querySelector(".newsletter-success")) {
      newsletter.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  function initAll(root) {
    root.querySelectorAll("[data-jkl-newsletter]").forEach(initNewsletter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(document));
  } else {
    initAll(document);
  }

  // Re-initialize on Shopify theme editor section load/rerender
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
